export { default } from "./InputText";